import { Bot } from 'lucide-react';

interface AgentBadgeProps {
  /** Human-readable label — from `GET /agents`' `name`, falling back to a
   *  humanised `agent_id` when the registry lookup misses. */
  label: string;
}

/** I1-E6 — per-turn attribution: which agent answered this turn. */
export default function AgentBadge({ label }: AgentBadgeProps) {
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-chart-10/30 border border-chart-10/40 text-xs font-medium text-chart-10">
      <Bot className="w-3 h-3" />
      {label}
    </span>
  );
}
